import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import McqQueSection from "../components/commonComponents/McqQueSection";
import { useDispatch, useSelector } from "react-redux";
import { fetchMcqData } from "../slices/mcqSlice";
import Loader from "../components/commonComponents/Loader";
import McqPracticeHeader from "../components/McqPracticeHeader";
import QuestionNavigator from "../components/QuestionNavigator";
import { useParams } from "react-router";


const McqPracticePage = () => {

  const dispatch = useDispatch();
  const { data, status, error } = useSelector((state) => state.mcq);
  const { topic, difficulty, noOfQuestions } = useParams();

  const passingArg = {
    topic: topic,
    difficulty: difficulty,
    noOfQuestions: noOfQuestions,
  };

  console.log(data?.data);

  useEffect(() => {
    dispatch(fetchMcqData(passingArg));
  }, [dispatch]);

  if (status === "loading") {
    return <Loader />;
  }

  if (status === "failed") {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="mcqPage">
      <div className="mcqPageLeft">
        <McqPracticeHeader />
        <McqQueSection apiData={data?.data} />
      </div>
      <div className="mcqPageRight">
        <QuestionNavigator data={data?.data} />
      </div>
    </div>
  );
};

export default McqPracticePage;
